<a href="" class="text-button-default -{{weight}}" #aTag [routerLink]="url" [queryParamsHandling]="queryParamsHandling">
  <mlp-ng-icon name="{{iconName}}" class="mr-1" *ngIf="iconName"></mlp-ng-icon>
  {{label}}
  <mlp-ng-icon name="{{iconNameAfter}}" [size]="iconNameAfterSize" class="ml-1" *ngIf="iconNameAfter"></mlp-ng-icon>
</a>
